import { useAppContext } from '../contexts/AppContext'

const ProgressBar = ({ progress = 0 }) => {
  const { accentColor } = useAppContext()

  return (
    <div className="shrink-0 h-[9px] rounded-[9px] overflow-hidden mt-4 mx-8 bg-zinc-300/45 dark:bg-zinc-300/30">
      <div
        style={{ width: !progress ? '18px' : `${progress}%`, background: accentColor }}
        className="h-full bg-black dark:bg-[#BFBFBF] rounded-[9px] transition-[width] duration-500"
      />
    </div>
  )
}

export default ProgressBar
